import { IResidentialComplex } from '../../types/residentials';
import { ResidentialComplexCard } from '../../components/ResidentialComplexCard';
import { Promo } from '../Promo';
import { Title } from '../Title';
import { FinishLabel } from '../FinishLabel';
import { SubwayInfo } from '../SubwayInfo';
import { RoomsList } from '../RoomsList';
import { BalloonImage } from '../BalloonImage';

interface IMapBalloonProps {
  complex: IResidentialComplex;
}

export function MapBalloon({ complex }: IMapBalloonProps) {
  const publicUrl = complex.publicUrl || '#';

  return (
    <ResidentialComplexCard
      hasClose
      url={publicUrl}
      promo={<Promo label={complex.promoLabel} />}
      image={<BalloonImage imageUrl={complex.imgUrl} complexName={complex.title} />}
      title={<Title title={complex.title} />}
      finishLabel={<FinishLabel label={complex.finishInfo?.label} />}
      subwayInfo={
        <SubwayInfo
          title={complex.undegroundInfo?.title}
          color={complex.undegroundInfo?.lineColor}
          timeToSubway={complex.undegroundInfo?.timeDisplay}
        />
      }
      rooms={<RoomsList roomsInfo={complex.roomsInfo} />}
    />
  );
}
